import { useEffect, useState } from "react";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia('(max-width: 639px)').matches
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 639px)');

    const listener = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return isMobile;
};

// export const useIsMobile = () => {
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const query = '(max-width: 639px)';
//     const media = window.matchMedia(query);
//     const listener = () => {
//       setIsMobile(media.matches);
//     }
//     setIsMobile(media.matches);
//     media.addEventListener('change', listener);
//     return () => media.removeEventListener('change', listener);
//   }, []);

//   return isMobile;
// };


export const useIsBreakPoint = () => {
  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia('(max-width: 639px)').matches
  );

  const [isLg1100, setIsLg1100] = useState(() =>
    window.matchMedia('(max-width: 1100px)').matches
  );

  useEffect(() => {
    const mediaXs = window.matchMedia('(max-width: 639px)');
    const mediaLg = window.matchMedia('(min-width: 1100px)');

    const listener = () => {
      // console.log("Width changed!", { 
      //   width: window.innerWidth, 
      //   mobile: mediaXs.matches, 
      //   large: mediaLg.matches 
      // });
      setIsMobile(mediaXs.matches);
      setIsLg1100(mediaLg.matches);
    };
    listener();
    mediaXs.addEventListener('change', listener);
    mediaLg.addEventListener('change', listener);
    return () => {
      mediaXs.removeEventListener('change', listener);
      mediaLg.removeEventListener('change', listener);
    };
  }, []);

  return {isMobile, isLg1100};
};
